import { IsString, IsNumber, Min, ValidateNested, IsDefined } from 'class-validator';
import { Type } from 'class-transformer';
import { RgbaDto } from './RgbaDto';
import { GradientDto } from './GradientDto';
import { ButtonSizeDto } from './ButtonSizeDto';
import { IsColorOrReference } from './validators/IsColorOrReference';
import { IsRgbaOrReference } from './validators/IsRgbaOrReference';

export class ButtonDto {
  @IsDefined()
  @IsString()
  fontFamily!: string;

  @IsDefined()
  @IsColorOrReference()
  fontColor!: RgbaDto | GradientDto | string;

  @IsColorOrReference()
  backgroundColor!: RgbaDto | GradientDto | string | null;

  @IsRgbaOrReference()
  borderColor!: RgbaDto | string | null;

  @IsColorOrReference()
  backgroundHoverColor!: RgbaDto | GradientDto | string | null;

  @IsRgbaOrReference()
  borderHoverColor!: RgbaDto | string | null;

  @IsColorOrReference()
  fontHoverColor!: RgbaDto | GradientDto | string | null;

  @IsDefined()
  @IsString()
  fontWeight!: string;

  @IsDefined()
  @IsNumber()
  letterSpacing!: number;

  @IsDefined()
  @IsNumber()
  @Min(0)
  borderWidth!: number;

  @IsDefined()
  @ValidateNested()
  @Type(() => ButtonSizeDto)
  small!: ButtonSizeDto;

  @IsDefined()
  @ValidateNested()
  @Type(() => ButtonSizeDto)
  medium!: ButtonSizeDto;

  @IsDefined()
  @ValidateNested()
  @Type(() => ButtonSizeDto)
  large!: ButtonSizeDto;
}
